<div>
  <app-breadcrumb></app-breadcrumb>
</div><div class="ticket-container">
<div class="ticket-header">
  <h2>{{ticket.detail}}</h2>
  <div class="ticket-meta">
    <span class="status-badge" [ngClass]="'status-' + ticket.status.toLowerCase()">
      {{ticket.status}}
    </span>
    <span class="priority-badge" [ngClass]="'priority-' + ticket.priority.toLowerCase()">
      {{ticket.priority}}
    </span>
    <span class="ticket-id">#{{ticket.id}}</span>
  </div>
</div>

<div class="ticket-description">
  <h3>Description</h3>
  <div class="ticket-body" [ngClass]="{'with-attachment': ticket.attachments?.length}">
    <div class="ticket-info">
      <!-- Render sanitized HTML description when available -->
      <div class="ticket-description-html" [innerHTML]="sanitizedDescription || ticket.description"></div>
    </div>

    <!-- Show video or image attachment preview -->
    @if (ticket.attachments?.length) {
      <div class="ticket-media">
        @for (att of ticket.attachments; track att) {
          @if (att.content_type.startsWith('video/')) {
            <video
              [src]="att.attachment_url"
              controls
              width="320"
              height="180"
            style="margin-bottom: 10px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.08);"></video>
          }
          @if (att.content_type.startsWith('image/')) {
            <img
              [src]="att.attachment_url"
              alt="attachment"
              class="ticket-image thumbnail"
              loading="lazy"
              width="320"
              height="180"
              (click)="openImageModal(att.attachment_url)" />
          }
        }
      </div>
    }
  </div>

  <!-- PDF, Excel aur Word files ke liye attachments section -->
  @if (getNonMediaAttachments().length > 0) {
    <div class="file-attachments-section">
      <h4>Attachments</h4>
      <div class="file-attachments-list">
        @for (file of getNonMediaAttachments(); track file) {
          <div class="file-attachment-item">
            <div class="file-icon">
              <span class="material-icons" [ngClass]="getFileIconClass(file)">{{getFileIcon(file)}}</span>
            </div>
            <div class="file-info">
              <div class="file-name">{{file.name}}</div>
              <div class="file-details">
                <span class="file-size">{{formatFileSize(file.size)}}</span>
                <span class="file-type">{{getFileType(file)}}</span>
              </div>
            </div>
            <div class="file-actions">
              <a [href]="file.attachment_url" target="_blank" class="btn-download" title="Download">
                <span class="material-icons">download</span>
              </a>
              @if (isPdfFile(file)) {
                <button class="btn-preview" (click)="previewPdf(file)" title="Preview">
                  <span class="material-icons">visibility</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

<!-- Fullscreen image modal -->
@if (showImageModal) {
  <div class="image-modal" (click)="closeImageModal()">
    <div class="image-modal-content">
      <div class="image-modal-card" (click)="$event.stopPropagation()">
        <div class="image-modal-inner">
          <img [src]="modalImageUrl" alt="full image" />
        </div>
      </div>
    </div>
  </div>
}

<!-- PDF Preview Modal -->
@if (showPdfModal) {
  <div class="pdf-modal" (click)="closePdfModal()">
    <div class="pdf-modal-content" (click)="$event.stopPropagation()">
      <div class="pdf-modal-header">
        <h4>{{currentPdfFile?.name}}</h4>
        <button class="close-btn" (click)="closePdfModal()">&times;</button>
      </div>
      <div class="pdf-modal-body">
        @if (pdfViewerUrl) {
          <iframe [src]="pdfViewerUrl"
          width="100%" height="600px" frameborder="0"></iframe>
        }
        @if (!pdfViewerUrl) {
          <div class="pdf-loading">
            Loading PDF preview...
          </div>
        }
      </div>
    </div>
  </div>
}

<div class="conversation-container">
  <h3>Comments</h3>

  <!-- Show comments section when expanded -->
  @if (showComments) {
    <div>
      @if (ticket.comments.length === 0) {
        <div class="no-comments">
          No comments yet. Be the first to comment!
        </div>
      }
      @if (!showComments && hasConversations) {
        <div class="loading-message" (click)="toggleComments()">
          Tap to load comments...
        </div>
      }
      <div class="comment-list">
        @for (comment of ticket.comments; track comment) {
          <div class="comment"
            [ngClass]="{'admin-comment': comment.isAdmin, 'user-comment': !comment.isAdmin}">
            <div class="comment-header">
              <span class="comment-time">{{comment.timestamp | date:'medium'}}</span>
            </div>
            <div class="comment-body">
              <strong>{{ comment.author || (comment.isAdmin ? 'Support Team' : 'User') }}:</strong>
              <span class="comment-text-content" style="margin-left: 6px;">
                {{ comment.text }}
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <div class="add-comment">
    <textarea [(ngModel)]="newComment" placeholder="Add a comment... Use @name or any email address to mention a user, including external users."></textarea>
    <button (click)="addComment()" [disabled]="!newComment.trim()">Post Comment</button>
  </div>
</div>
</div>
